import { DatePipe                      } from '@angular/common';
import { Component, OnInit, Inject, ViewChild     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { tr } from 'date-fns/locale';
import { Moment } from 'moment';
import { User } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { Service } from 'src/app/beans/service/service.bean';
import { SiteAutocomplete } from 'src/app/components/autocomplete/site/site.autocomplete';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'slot-mass-import-dialog',
  templateUrl: './slot.mass.import.dialog.html',
  styleUrls: ['./slot.mass.import.dialog.scss'],
})

export class SlotMassImportDialog implements OnInit 
{
  dateBegin: string
  dateEnd  : string

  service : Service
  bookableDayId: number

  operations_title = "dialog.slot.mass_import.operations.title"

  orgId: number

  currentDate: string

  dayList: any[] =
  [
    {
      day   : "day.monday",
      active: true
    },
    {
      day   : "day.tuesday",
      active: true
    },
    {
      day   : "day.wednesday",
      active: true
    },
    {
      day   : "day.thursday",
      active: true
    },
    {
      day   : "day.friday",
      active: true
    },
    {
      day   : "day.saturday",
      active: false
    },
    {
      day   : "day.sunday",
      active: false
    },
  ]

  operations: any[] =
  [
    {
      name: "dialog.slot.mass_import.operations.j",
      type: "J"
    },
    {
      name: "dialog.slot.mass_import.operations.i",
      type: "I"
    },
    {
      name: "dialog.slot.mass_import.operations.d",
      type: "D"
    },
    {
      name: "dialog.slot.mass_import.operations.x",
      type: "X"
    },
  ]

  days    : string //Number of week day -> 1111011
  siteList: string //Array of site list
  holidays: number //Holiday enable 1 -> disable 0
  
  byServiceCode: number //byServiceCode enable 1 -> disable 0


  selectedOperation: string

  @ViewChild('sitesManager') sitesManager: SiteAutocomplete;

  constructor
  (
    private dialogRef : MatDialogRef<SlotMassImportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler  : HandlerManager,
    private _loader   : LoadingManager,
    private _session  : SessionManager,
    private _datePipe : DatePipe      ,
    private _utils    : UtilsManager
  ) {}

  ngOnInit(): void
  {
    console.log(this.data);
    
    if(this.data.currentDate){
      this.currentDate = this.data.currentDate
    }

    if(this.data.orgId         ) this.orgId         = this.data.orgId
    if(this.data.service       ) this.service       = this.data.service
    if(this.data.bookableDayId ) this.bookableDayId = this.data.bookableDayId

    let minDate     = new Date(this.currentDate)
    this.dateBegin  = this._datePipe.transform(new Date(minDate.setDate(minDate.getDate() + 1)), 'yyyy-MM-dd')
    this.dateEnd    = this._datePipe.transform(new Date(minDate.setDate(minDate.getDate())), 'yyyy-MM-dd')

  }

  //---------------------------------------------------------------------------------------------------

  async create()
  {
    this.defaultControl()
    
    let response = null
    response = this.massImport()
    
    this.acceptOperation(response)
  }

  acceptOperation(response: any)
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.SLOT_MASS_IMPORT_ACCEPTED
        }
      )
    }
  }

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  //---------------------------------------------------------------------------------------------------

  async massImport() 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    let response = null
    response = await this._handler.slot().massImport((user as User).token, this.service.serviceCode, this.service.id, this.bookableDayId, this.selectedOperation, this.days, this.siteList, this.dateBegin, this.dateEnd, this.holidays)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

  defaultControl()
  {
    this.dateBegin = this._datePipe.transform(this.dateBegin, 'yyyy-MM-dd')
    this.dateEnd   = this._datePipe.transform(this.dateEnd  , 'yyyy-MM-dd')

    this.days = ""
    this.dayList.forEach(day => {

      if(day.active) this.days += "1"
      else           this.days += "0"

    });

    this.holidays = this.holidays ? 1 : 0

    this.siteList = ""
    if ( this.byServiceCode == 1 && this.sitesManager) {
      this.sitesManager.getSelected().forEach(site => {
        this.siteList += site.id + ","
      });   
    }else{
      this.siteList = this.service.siteId.toString()
    }
 
  }

  operationChange(el: any)
  {
    this.selectedOperation = el.type
    console.log(this.selectedOperation)
  }

  excludeToday = (date: Moment): boolean =>
  {        
    if (!this.currentDate) return true
    return !this._utils.date().isSameDay(date.toDate(), this.currentDate)
  }
}
